<template>
  <v-container class="formulario-wrapper" fluid pa-0 fill-height>
    <div class="content-container elevation-2">
      <v-card class="d-flex flex-column fill-height">

        <div v-if="loading" class="text-center pa-8 flex-grow-1">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p class="mt-4 mb-0">Carregando dados...</p>
        </div>

        <simplebar
          v-else-if="!loading && resultados.length > 0"
          data-simplebar
          :autoHide="false"
          class="lista-resultados-container flex-grow-1"
        >
          <v-list class="py-0">
            <template v-for="(item, index) in resultados">
              <v-list-item
                :key="item.codigo"
                class="resultado-item-clicavel"
                @click="itemClicado(item)"
              >
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    Código: {{ item.codigo }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--primary mt-1">
                    Descrição: {{ item.descricao }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                
                <v-list-item-action>
                  <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index < resultados.length - 1" :key="`divider-${index}`"></v-divider>
            </template>
          </v-list>
        </simplebar>

        <div v-else class="text-center pa-8 flex-grow-1">
          <v-icon size="64" color="grey lighten-2">mdi-database-off</v-icon>
          <p class="mb-0 grey--text">Nenhum item encontrado.</p>
        </div>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import db from '@/plugins/dexie';

export default {
  name: 'ViewPesquisaGenericaLista', 

  components: {
    simplebar,
  },

  data() {
    return {
      loading: false,
      resultados: [],
    };
  },

  computed: {
    tituloLista() {
      return this.$route.query.tipo || 'Lista de Registros';
    }
  },

  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler() {
        this.carregarDados();
      },
    },
  },

  methods: {
    itemClicado(item) {
      const tipoPesquisa = this.$route.query.tipo;
      
      const payload = {
        tipo: tipoPesquisa,
        codigo: item.codigo,     
        descricao: item.descricao,
        dadosExtras: {}
      };

      if (tipoPesquisa === 'Tipo de Pagamento' && item.original) {
        payload.dadosExtras = {
          idPlano: item.original.idplanopagto || item.original.idPlanoPagto,
          idForma: item.original.IdFormaPagto || item.original.idFormaPagto,
          idDestino: item.original.IdDestinoItem || item.original.idDestinoItem
        };
      }

      sessionStorage.setItem('pesquisaResultado', JSON.stringify(payload));
      
      this.$router.back();
    },

    async carregarDados() {
      this.loading = true;

      const { 
        tipo: tipoPesquisa, 
        codigo, 
        descricao 
      } = this.$route.query;

      let collection;
      let idKey;
      let descKey;

      switch (tipoPesquisa) {
        case 'Tipo de Pagamento':
          collection = db.tipopedidovenda; 
          idKey = 'idtipopedidovenda'; 
          descKey = 'descricao';
          break;

        case 'Plano de Pagamento':
          collection = db.planopagamento;
          idKey = 'idplanopagto';
          descKey = 'descricao';      
          break;

        case 'Forma de Pagamento':
          collection = db.formapagto;
          idKey = 'idformapagto';
          descKey = 'descricao';
          break;

        case 'Destino da Mercadoria':
          collection = db.destinoitem;
          idKey = 'iddestinoitem';
          descKey = 'descricao';
          break;

        default:
          console.warn('Tipo não mapeado:', tipoPesquisa);
          this.resultados = [];
          this.loading = false;
          return;
      }

      if (!collection) {
        console.error(`Tabela não encontrada no Dexie para: ${tipoPesquisa}`);
        this.loading = false;
        return;
      }

      try {
        let query = collection;

        if (codigo) {
          const idNum = parseInt(codigo, 10);
          if (!isNaN(idNum)) {
            query = collection.where(idKey).equals(idNum);
          }
        } else if (descricao) {
          query = collection.where(descKey).startsWithIgnoreCase(descricao);
        } else {
          query = collection.limit(100);
        }

        const dadosDoBanco = await query.toArray();

        this.resultados = dadosDoBanco.map(item => {
          let valCodigo = item[idKey];
          let valDesc = item[descKey];

          if (valCodigo === undefined) {
            const keyCamel = idKey.charAt(0).toLowerCase() + idKey.slice(1);
            valCodigo = item[keyCamel];
          }
          if (valCodigo === undefined) {
            valCodigo = item[idKey.toLowerCase()];
          }

          if (valDesc === undefined) {
            const descCamel = descKey.charAt(0).toLowerCase() + descKey.slice(1);
            valDesc = item[descCamel];
          }
          if (valDesc === undefined) {
            valDesc = item[descKey.toLowerCase()];
          }

          return {
            codigo: valCodigo,
            descricao: valDesc,
            original: item 
          };
        });

      } catch (error) {
        console.error(`Erro ao buscar dados (${tipoPesquisa}):`, error);
        this.resultados = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.formulario-wrapper {
  background-color: #f5f5f5;
}
.content-container {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  height: 100%;  
  background: white;
}
.lista-resultados-container {
  overflow-y: auto;
}
.resultado-item-clicavel {
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.resultado-item-clicavel:hover {
  background-color: #e3f2fd; 
}
</style>